import { render, staticRenderFns } from "./UniSearchCard.vue?vue&type=template&id=b607a25c&scoped=true&"
import script from "./UniSearchCard.vue?vue&type=script&lang=js&"
export * from "./UniSearchCard.vue?vue&type=script&lang=js&"
import style0 from "./UniSearchCard.vue?vue&type=style&index=0&id=b607a25c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b607a25c",
  null
  
)

export default component.exports